import { IFormViewForm } from 'components/FormView';
const AddBinLocation: { [x: string]: IFormViewForm } = {
    Form: {
        id: 'AddLotsForm',
        layout: {
            rows: 1,
            columns: 2,
        },
        fields: [
            {
                id: '1',
                type: 'PAPER_CONTAINER',
                visible: true,
                props: {
                    name: 'activity',
                    fullWidth: true,
                    elevation: 0
                },
                position: {
                    row: 1,
                    col: 1
                },
                children: [
                    {
                        id: 1,
                        type: 'EX_LOOKUP_FIELD',
                        props: {
                            label: 'Bin',
                            name: 'Bin',
                            lookupName: 'ProductBinMaster',
                            isWarehouseProductScoped: true,
                            size: 'small',
                            required: true,
                        }
                    },
                    {
                        id: 2,
                        type: 'TEXT_FIELD',
                        props: {
                            label: 'Quantity',
                            name: 'Quantity',
                            placeholder: '',
                            size: 'small',
                            decimalSeparator: true,
                            alignment: 'right',
                            decimalPlaces: 2
                        },
                    },
                    {
                        id: 3,
                        type: 'TOGGLE_FIELD',
                        visible: true,
                        props: {
                            name: 'SaveLocation',
                            label: 'Save product bin location',
                        }
                    },
                ]
            }
        ]
    }
};
export default AddBinLocation;
